import React from 'react';
import Lab from '../assets/lab.jpg'
import Teacher from '../assets/teacher2.jpg'


function Intro() {
  return (
    <div className='md:w-7/12 sm:w-3/4  mx-auto h-auto'  id="intro">
        <div className='flex flex-col md:flex-row w-full justify-between my-24 h-auto items-center'>
            <div className="overflow-hidden relative">
                <img src={Lab} alt='' className="lg:w-96 lg:h-96 md:w-72 md:h-72 md:order-1 rounded-xl shadow-xl object-cover  transition-transform transform hover:scale-110 cursor-pointer duration-1000 ease-in-out"></img>
            </div>
            <div className="md:w-2/5 md:order-2 py-12 sm:px-4 md:px-0">
                <h3 className='text-[#34623F] lg:text-2xl md:text-xl mb-6 md:tracking-widest font-semibold '>
                实验室方向介绍
                </h3>
                <p className='lg:text-base sm:text-sm text-[#34623F] sm:tracking-widest sm:leading-loose lg:leading-loose'>
                    中国海洋大学三维实验室，深耕图形学领域，致力于探索实时渲染、三维可视化等前沿技术。同时，实验室结合海洋特色，开展海洋数据超分辨率等独特研究。此外，计算机视觉、AIGC、人机交互等也是我们的研究重点。在这里，科技与创意碰撞，激发无限可能。                </p>
            </div>
        </div>
        <div className='flex flex-col md:flex-row w-full justify-between my-24 h-auto items-center'>
            <div className="relative overflow-hidden md:order-2" >
                <img src={Teacher} alt='' className="lg:w-96 lg:h-96 md:w-72 md:h-72  rounded-xl shadow-xl object-cover transition-all transform hover:scale-110  cursor-pointer duration-1000 ease-in-out"></img>
            </div>
            <div className="md:w-2/5 md:order-1 py-12 sm:px-4 md:px-0">
                <h3 className='text-[#34623F] lg:text-2xl md:text-xl mb-6 md:tracking-widest font-semibold '>
                导师介绍
                </h3>
                <p className='lg:text-base sm:text-sm text-[#34623F] sm:tracking-widest sm:leading-loose lg:leading-loose ' >
                    王欣捷，2010年本科毕业于武汉大学计算机学院，2015年博士毕业于浙江大学CAD&CG国家重点实验室。现为中国海洋大学计算机科学与技术学院现任教师、硕士生导师。研究方向为计算机图形学、三维可视化、混合现实、基于深度学习的数值模式降尺度等。
                </p>
            </div>
        </div>
    </div>
  )
}
export default Intro
